import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocalStorage } from 'react-use';
import {
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import { Typeahead } from 'react-bootstrap-typeahead';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';

const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {

  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert();

  const [scope, setScope] = useState(-1);
  const [scopes, setScopes] = useState([]);
  const [auditee, setAuditee] = useState(-1);
  const [auditees, setAuditees] = useState([]);
  const [instrument, setInstrument] = useState(-1);
  const [instruments, setInstruments] = useState([]);
  const [selectedInstrument, setSelectedInstrument] = useState(null);
  const [selectedAuditee, setSelectedAuditee] = useState(null);

  const fetchScopes = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scopes`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: { all: true }
      });

      setScopes(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchAuditees = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}auditees`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: 'department',
          SCOPE_ID: scope,
          all: true
        }
      });

      setAuditee(-1);
      setAuditees(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchInstruments = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}instruments`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: 'standard',
          'per-page': 50,
          INSTRUMENT_STATUS: 'PUBLISHED',
          all: true
        }
      });

      setInstruments(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleAuditeeChange = (selected) => {
    const value = selected.length > 0 ? selected[0].AUDITEE_ID : null;
    setSelectedAuditee(value);

    const fakeEvent = {
      target: {
        name: 'AUDITEE_ID',
        value: value
      }
    };
    onChange(fakeEvent);
  };

  const handleInstrumentChange = (selected) => {
    const value = selected.length > 0 ? selected[0].INSTRUMENT_ID : null;
    setSelectedInstrument(value);

    const fakeEvent = {
      target: {
        name: 'INSTRUMENT_ID',
        value: value
      }
    };
    onChange(fakeEvent);
  };

  useEffect(() => {
    fetchScopes();
    fetchInstruments();
  }, []);


  useEffect(() => {
    if (scope > 0) {
      fetchAuditees();
    }
  }, [scope]);

  return (
    <Modal
      show={open}
      onHide={onCancelChanges}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>New Instrument Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Scope</Form.Label>
          <Typeahead
            id="scope-selector"
            labelKey="SCOPE_NAME"
            options={scopes}
            selected={scopes.filter(s => s.SCOPE_ID === scope)}
            onChange={(selected) => {
              if (selected.length > 0) {
                setScope(selected[0].SCOPE_ID);
              } else {
                setScope(null);
              }
            }}
            placeholder="Please Select..."
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Auditee</Form.Label>
            <Typeahead
              id="auditee-typeahead"
              labelKey={(option) => option.department.DEPT_NAME}
              options={auditees}
              selected={auditees.filter((a) => a.AUDITEE_ID === selectedAuditee)}
              onChange={handleAuditeeChange}
              placeholder="Please Select..."
            />
          {/* <Form.Control
            as="select"
            name="AUDITEE_ID"
            defaultValue={-1}
            onChange={onChange}
          >
            <option disabled value={-1}>Please Select...</option>
            {auditees && auditees.map((auditee, key) => (
              <option key={key} value={auditee.AUDITEE_ID}>{auditee.department.DEPT_NAME}</option>
            ))}
          </Form.Control> */}
        </Form.Group>
        <Form.Group>
          <Form.Label>Template</Form.Label>
          <Typeahead
            id="auditee-instrument"
            labelKey={(option) =>
              option.standard.STANDARD_NAME + ' || ' + option.INSTRUMENT_NAME
            }
            options={instruments}
            selected={
              instruments.filter((a) => a.INSTRUMENT_ID === selectedInstrument)
            }
            onChange={handleInstrumentChange}
            placeholder="Please Select..."
          />
          {/* <Form.Control
            as="select"
            name="INSTRUMENT_ID"
            defaultValue={-1}
            onChange={onChange}
          >
            <option disabled value={-1}>Please Select...</option>
            {instruments && instruments.map((instrument, key) => (
              <option key={key} value={instrument.INSTRUMENT_ID}>{instrument.standard.STANDARD_NAME} - {instrument.INSTRUMENT_NAME}</option>
            ))}
          </Form.Control> */}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelChanges}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onApplyChanges}>Save</Button>
      </Modal.Footer>
    </Modal>
  )
};

export default Popup;